var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroupierWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-contraception-methods:not(.animated) .animable {opacity: 0;}svg#freepik_stories-contraception-methods.animated #freepik--contraception-methods--inject-69 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}svg#freepik_stories-contraception-methods.animated #freepik--Character--inject-69 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "267.587px 199.665px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m106.09 319.86c-23.77-29.66-9-85.76 27-119.87 31.44-29.75 65.25-26.63 92.7-65 25.58-35.75 39.05-74 87.62-89.17 38.23-11.92 64.41 7.26 87.59 29.62 63.42 61.16 49.62 125.45-33.24 191.18-39.6 31.38-91.61 66.16-138.46 81.51-56.22 18.42-93.75 8.51-123.21-28.27z",
    fill: "#16A085",
    style: {
      transformOrigin: "267.587px 199.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m106.09 319.86c-23.77-29.66-9-85.76 27-119.87 31.44-29.75 65.25-26.63 92.7-65 25.58-35.75 39.05-74 87.62-89.17 38.23-11.92 64.41 7.26 87.59 29.62 63.42 61.16 49.62 125.45-33.24 191.18-39.6 31.38-91.61 66.16-138.46 81.51-56.22 18.42-93.75 8.51-123.21-28.27z",
    fill: "#fff",
    opacity: 0.9,
    style: {
      transformOrigin: "267.587px 199.665px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable animator-hidden",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "250px 416.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "257.39px 146.97px"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 250.6,
    cy: 52.47,
    r: 20.58,
    fill: "#16A085",
    style: {
      transformOrigin: "250.6px 52.47px",
      transform: "rotate(-2.85deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "253.56 52.01 248.43 54.54 244.1 45.76 245.93 43.01 249.23 43.23",
    fill: "#fff",
    style: {
      transformOrigin: "248.83px 48.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M246.47,44.6a.51.51,0,0,1-.45-.27L243,38.14a.5.5,0,0,1,.9-.44l3,6.18a.5.5,0,0,1-.23.67A.42.42,0,0,1,246.47,44.6Z",
    fill: "#fff",
    style: {
      transformOrigin: "244.95px 41.0096px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "256.81 58.59 253.81 52.5 248.68 55.03 251.68 61.12 249.96 61.97 250.31 62.67 258.87 58.44 258.53 57.74",
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "253.775px 57.585px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "257.65 63.62 252.49 53.16 250 54.38 255.16 64.84 254.32 65.26 254.68 65.97 258.83 63.92 258.48 63.2",
    fill: "#fff",
    style: {
      transformOrigin: "254.415px 59.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m347.82 89.28a20.58 20.58 0 1 1-4.59-28.74 20.58 20.58 0 0 1 4.59 28.74z",
    fill: "#16A085",
    style: {
      transformOrigin: "331.155px 77.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M338.13,66.69,334.28,72a.16.16,0,0,1-.26,0c-.38-.65-1.23-2.91,3.91-5.53A.16.16,0,0,1,338.13,66.69Z",
    fill: "#fff",
    style: {
      transformOrigin: "335.934px 69.2633px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M327.65,87.79a.53.53,0,0,1-.24-.06.49.49,0,0,1-.19-.68l7.59-13.69a.87.87,0,0,0,0-.91l-.7-1a.49.49,0,0,1,.13-.69.5.5,0,0,1,.69.12l.7,1a1.87,1.87,0,0,1,.1,2l-7.6,13.7A.5.5,0,0,1,327.65,87.79Z",
    fill: "#fff",
    style: {
      transformOrigin: "331.562px 79.2332px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m329.7 91.81a3.07 3.07 0 1 1 0.48 0 2.59 2.59 0 0 1-0.48 0zm0-5.06a1.83 1.83 0 0 0-0.33 0 2 2 0 0 0-1.32 0.82 2 2 0 0 0 0.45 2.83 2 2 0 0 0 2.84-0.45 2 2 0 0 0-1.64-3.22z",
    fill: "#fff",
    style: {
      transformOrigin: "329.94px 88.7503px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M339,67.31l-3.85,5.31a.15.15,0,0,0,.08.24c.74.17,3.16.26,4-5.44A.15.15,0,0,0,339,67.31Z",
    fill: "#fff",
    style: {
      transformOrigin: "337.173px 70.0992px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M322.67,84.18a.48.48,0,0,1-.34-.14.48.48,0,0,1,0-.7L333,71.85a1.85,1.85,0,0,1,1.89-.51l1.17.35a.49.49,0,0,1,.34.62.5.5,0,0,1-.62.33l-1.17-.35a.87.87,0,0,0-.88.24L323,84A.52.52,0,0,1,322.67,84.18Z",
    fill: "#fff",
    style: {
      transformOrigin: "329.301px 77.7203px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m320.61 85.23a3 3 0 0 1-1.77-0.58 3 3 0 0 1-0.68-4.24 3.05 3.05 0 0 1 2-1.21 3 3 0 0 1 2.25 0.54 3 3 0 0 1-1.3 5.45 3.88 3.88 0 0 1-0.5 0.04zm0-5.07a1.84 1.84 0 0 0-0.33 0 2 2 0 0 0-1.28 0.84 2 2 0 1 0 2.84-0.45 2 2 0 0 0-1.22-0.39zm-2.06 0.55z",
    fill: "#fff",
    style: {
      transformOrigin: "320.642px 82.1958px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 376.97,
    cy: 147.93,
    r: 20.58,
    fill: "#16A085",
    style: {
      transformOrigin: "376.97px 147.93px",
      transform: "rotate(-14.13deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m390 145.74-4.41 14a3.09 3.09 0 0 1-3.85 2l-16.58-5.22a3.07 3.07 0 0 1-2-3.85l5.22-16.57a3.07 3.07 0 0 1 3.85-2l14 4.41-0.8 2.56a3.07 3.07 0 0 0 2 3.85z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "376.509px 147.918px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M388.4,145.24l-4.41,14a1.41,1.41,0,0,1-1.76.92L365.66,155a1.42,1.42,0,0,1-.92-1.76L370,136.62a1.4,1.4,0,0,1,1.76-.91l14,4.41-.3,1a3.07,3.07,0,0,0,2,3.85Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "376.54px 147.933px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M377.81,148.2a.88.88,0,1,1-.57-1.11A.89.89,0,0,1,377.81,148.2Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "376.972px 147.928px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M376.91,151.08a.88.88,0,0,1-1.11.58.9.9,0,0,1-.58-1.11.89.89,0,0,1,1.69.53Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "376.056px 150.856px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M378.72,145.32a.88.88,0,1,1-.57-1.11A.88.88,0,0,1,378.72,145.32Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "377.883px 145.049px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M380.7,149.11a.88.88,0,0,1-1.11.57.88.88,0,0,1,.53-1.68A.89.89,0,0,1,380.7,149.11Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "379.857px 148.841px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M379.79,152a.88.88,0,1,1-1.68-.53.88.88,0,0,1,1.68.53Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "378.95px 151.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M381.61,146.22a.88.88,0,0,1-1.11.58.9.9,0,0,1-.58-1.11.89.89,0,0,1,1.69.53Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "380.756px 145.996px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M383.58,150a.88.88,0,0,1-1.68-.52.88.88,0,1,1,1.68.52Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "382.75px 149.707px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M382.67,152.9a.88.88,0,1,1-.57-1.11A.89.89,0,0,1,382.67,152.9Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "381.832px 152.628px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M384.49,147.13a.88.88,0,1,1-.58-1.11A.89.89,0,0,1,384.49,147.13Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "383.651px 146.861px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M374.93,147.29a.88.88,0,1,1-.58-1.11A.89.89,0,0,1,374.93,147.29Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "374.091px 147.021px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M374,150.18a.88.88,0,1,1-.57-1.11A.88.88,0,0,1,374,150.18Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "373.163px 149.908px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M375.84,144.41a.88.88,0,0,1-1.11.57.88.88,0,0,1,.53-1.68A.89.89,0,0,1,375.84,144.41Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "374.998px 144.141px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M372.05,146.38a.88.88,0,0,1-1.11.58.9.9,0,0,1-.58-1.11.89.89,0,0,1,1.69.53Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "371.196px 146.156px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M371.14,149.27a.88.88,0,0,1-1.11.57.88.88,0,0,1,.53-1.68A.89.89,0,0,1,371.14,149.27Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "370.297px 149.001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M373,143.5a.88.88,0,1,1-.57-1.11A.89.89,0,0,1,373,143.5Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "372.162px 143.229px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386.23,138.52l-.81,2.56a3.09,3.09,0,0,0,2,3.85l2.56.81Z",
    fill: "#fff",
    style: {
      transformOrigin: "387.631px 142.13px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 172.99,
    cy: 85.31,
    r: 20.58,
    fill: "#16A085",
    style: {
      transformOrigin: "172.99px 85.31px",
      transform: "rotate(-22.5deg)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.4,
    style: {
      transformOrigin: "173px 85.31px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M173,71.62a13.69,13.69,0,1,0,13.69,13.69A13.68,13.68,0,0,0,173,71.62Zm0,24.1A10.42,10.42,0,1,1,183.4,85.31,10.41,10.41,0,0,1,173,95.72Z",
    fill: "#fff",
    style: {
      transformOrigin: "173px 85.31px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.4,
    style: {
      transformOrigin: "173px 85.34px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M173,74a11.34,11.34,0,1,0,11.34,11.34A11.34,11.34,0,0,0,173,74Zm0,21.75A10.42,10.42,0,1,1,183.4,85.31,10.41,10.41,0,0,1,173,95.72Z",
    fill: "#fff",
    style: {
      transformOrigin: "173px 85.34px"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 366.6,
    cy: 231.56,
    r: 20.58,
    fill: "#16A085",
    style: {
      transformOrigin: "366.6px 231.56px",
      transform: "rotate(-80.59deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 353.74,
    y: 225.82,
    width: 25.72,
    height: 11.5,
    rx: 1.58,
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "366.6px 231.57px",
      transform: "rotate(54.41deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m369.68 231.29a1.57 1.57 0 1 1 0.36-2.19 1.58 1.58 0 0 1-0.36 2.19z",
    fill: "#fff",
    style: {
      transformOrigin: "368.762px 230.015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m365.35 234.39a1.57 1.57 0 1 1 0.36-2.19 1.56 1.56 0 0 1-0.36 2.19z",
    fill: "#fff",
    style: {
      transformOrigin: "364.436px 233.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m372.39 235.08a1.57 1.57 0 1 1 0.36-2.19 1.57 1.57 0 0 1-0.36 2.19z",
    fill: "#fff",
    style: {
      transformOrigin: "371.474px 233.805px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m368.06 238.17a1.56 1.56 0 1 1 0.36-2.18 1.56 1.56 0 0 1-0.36 2.18z",
    fill: "#fff",
    style: {
      transformOrigin: "367.153px 236.901px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m375.1 238.86a1.57 1.57 0 1 1 0.36-2.18 1.58 1.58 0 0 1-0.36 2.18z",
    fill: "#fff",
    style: {
      transformOrigin: "374.177px 237.588px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m370.77 242a1.57 1.57 0 1 1 0.36-2.19 1.57 1.57 0 0 1-0.36 2.19z",
    fill: "#fff",
    style: {
      transformOrigin: "369.854px 240.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M367,227.5a1.56,1.56,0,1,1,.36-2.18A1.57,1.57,0,0,1,367,227.5Z",
    fill: "#fff",
    style: {
      transformOrigin: "366.091px 226.231px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m362.64 230.6a1.57 1.57 0 1 1 0.36-2.18 1.55 1.55 0 0 1-0.36 2.18z",
    fill: "#fff",
    style: {
      transformOrigin: "361.723px 229.328px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m364.26 223.72a1.57 1.57 0 1 1 0.36-2.19 1.58 1.58 0 0 1-0.36 2.19z",
    fill: "#fff",
    style: {
      transformOrigin: "363.342px 222.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m359.93 226.81a1.56 1.56 0 1 1 0.36-2.18 1.55 1.55 0 0 1-0.36 2.18z",
    fill: "#fff",
    style: {
      transformOrigin: "359.025px 225.541px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m166.62 258.33a20.58 20.58 0 1 1 2.73-29 20.58 20.58 0 0 1-2.73 29z",
    fill: "#16A085",
    style: {
      transformOrigin: "153.509px 242.467px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m142.07 251.94a1.23 1.23 0 0 1 0.16-1.72l21-17.36a1.22 1.22 0 0 1 1.72 0.16 1.22 1.22 0 0 1-0.16 1.72l-21 17.36a1.22 1.22 0 0 1-1.72-0.16z",
    fill: "#fff",
    opacity: 0.6,
    style: {
      transformOrigin: "153.512px 242.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M161.49,235.87h0a.82.82,0,0,1,.11-1.16l1.64-1.36a.83.83,0,0,1,1.16.11h0a.84.84,0,0,1-.11,1.16L162.64,236A.81.81,0,0,1,161.49,235.87Z",
    fill: "#fff",
    opacity: 0.6,
    style: {
      transformOrigin: "162.941px 234.673px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M143.87,249.75h0a.28.28,0,0,1,0-.39l11.73-9.71a.28.28,0,0,1,.39,0h0a.28.28,0,0,1,0,.39l-11.73,9.71A.28.28,0,0,1,143.87,249.75Z",
    fill: "#fff",
    opacity: 0.6,
    style: {
      transformOrigin: "149.93px 244.7px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 134.64,
    cy: 160.35,
    r: 20.58,
    fill: "#16A085",
    style: {
      transformOrigin: "134.64px 160.35px",
      transform: "rotate(-86.46deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 121.21,
    y: 149.63,
    width: 26.88,
    height: 21.44,
    rx: 2.1,
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "134.65px 160.35px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m120.36 157.56 2.83 13.91a2.11 2.11 0 0 0 2.48 1.64l22.22-4.52a2.1 2.1 0 0 0 1.64-2.47l-2.83-13.91z",
    fill: "#fff",
    style: {
      transformOrigin: "134.965px 162.681px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 135.66,
    y: 156.54,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "137.335px 157.915px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 136.48,
    y: 160.58,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "138.155px 161.955px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 141.78,
    y: 155.3,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "143.455px 156.675px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 142.6,
    y: 159.34,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "144.275px 160.715px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 129.54,
    y: 157.78,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "131.215px 159.155px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 130.36,
    y: 161.83,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "132.035px 163.205px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 123.42,
    y: 159.03,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "125.095px 160.405px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 124.24,
    y: 163.07,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "125.915px 164.445px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.3,
    y: 164.62,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "138.975px 165.995px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 143.43,
    y: 163.38,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "145.105px 164.755px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 131.18,
    y: 165.87,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "132.855px 167.245px",
      transform: "rotate(-11.49deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 125.06,
    y: 167.11,
    width: 3.35,
    height: 2.75,
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "126.735px 168.485px",
      transform: "rotate(-11.49deg)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "255.133px 269.558px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m290.93 126.21c13.24-0.74 21 12.21 13.32 20.45s-2.22 12.29 0.87 13.79c-3.38 9.74-30.44 11.08-36.18 2.86-4.82-6.9 14-15.78 9.46-23.31s2.23-14 12.53-13.79z",
    fill: "#263238",
    style: {
      transformOrigin: "287.717px 147.443px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m210.9 184.63 1.86 2.09a3.25 3.25 0 0 0 2.78 1.08l4.89-0.52a6.09 6.09 0 0 0 4.66-3.07l0.59-1.06c-2.84-3.68-8.63-5.57-8.63-5.57l-1.59-0.72a2.71 2.71 0 0 0-3.64 1.27l-1.47 3.13a3.12 3.12 0 0 0 0.55 3.37z",
    fill: "#ffb573",
    style: {
      transformOrigin: "217.881px 182.201px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M273.44,184.15c-1.07,1.2-2,2.24-3.07,3.33s-2.05,2.12-3.09,3.17c-2.09,2.09-4.2,4.16-6.4,6.16a93.73,93.73,0,0,1-14.55,11.25l-.05,0a4,4,0,0,1-.4.22,10.14,10.14,0,0,1-4.68,1,12.36,12.36,0,0,1-3.57-.69,19.49,19.49,0,0,1-4.67-2.43,45,45,0,0,1-6.35-5.51c-1.86-1.88-3.57-3.8-5.2-5.76s-3.19-3.87-4.79-6l9.9-7.05c1.24,1.74,2.69,3.65,4.12,5.38s3,3.43,4.51,5a33.12,33.12,0,0,0,4.64,3.9,7.79,7.79,0,0,0,1.74.9c.15.05.18,0,0,0a2.37,2.37,0,0,0-1.17.26l-.45.24a62.3,62.3,0,0,0,6.12-4.6c2-1.7,4-3.55,5.89-5.47s3.79-3.91,5.61-5.95c.9-1,1.8-2.06,2.68-3.11s1.77-2.13,2.53-3.1Z",
    fill: "#16A085",
    style: {
      transformOrigin: "245.03px 192.287px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M273.44,184.15c-1.07,1.2-2,2.24-3.07,3.33s-2.05,2.12-3.09,3.17c-2.09,2.09-4.2,4.16-6.4,6.16a93.73,93.73,0,0,1-14.55,11.25l-.05,0a4,4,0,0,1-.4.22,10.14,10.14,0,0,1-4.68,1,12.36,12.36,0,0,1-3.57-.69,19.49,19.49,0,0,1-4.67-2.43,45,45,0,0,1-6.35-5.51c-1.86-1.88-3.57-3.8-5.2-5.76s-3.19-3.87-4.79-6l9.9-7.05c1.24,1.74,2.69,3.65,4.12,5.38s3,3.43,4.51,5a33.12,33.12,0,0,0,4.64,3.9,7.79,7.79,0,0,0,1.74.9c.15.05.18,0,0,0a2.37,2.37,0,0,0-1.17.26l-.45.24a62.3,62.3,0,0,0,6.12-4.6c2-1.7,4-3.55,5.89-5.47s3.79-3.91,5.61-5.95c.9-1,1.8-2.06,2.68-3.11s1.77-2.13,2.53-3.1Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "245.03px 192.287px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M297.14,416.23c7,0,6.46-.11,10.37-.24,3.35-.12,4.14.3,6.82.24,2.25-.05,2.22-2.2,1.6-4.67-.32-1.24-.81-2.76-1.24-4.77H304.13a10.86,10.86,0,0,1-8.35,5.32C292,412.61,294.37,416.23,297.14,416.23Z",
    fill: "#16A085",
    style: {
      transformOrigin: "305.055px 411.513px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m244.73 416.23c6.83 0 9.13-0.45 13-0.58 3.3-0.12 3.81 0.58 7.15 0.58 2.21 0 2.63-2.49 1.91-4.36a28.7 28.7 0 0 1-1.91-5.08h-9.43c-1.84 3-6.57 5.2-11.77 5.57-3.75 0.27-1.68 3.87 1.05 3.87z",
    fill: "#16A085",
    style: {
      transformOrigin: "254.377px 411.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M261.43,230s-3.66,49.16-2.21,80.38c-1.56,29.31-3.8,96.43-3.8,96.43.16,1.5,8.05.9,9.43,0,0,0,17-48.89,12.7-96.43C296.23,260.78,294.14,230,294.14,230Z",
    fill: "#263238",
    style: {
      transformOrigin: "274.815px 318.862px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.24,230s14.51,55.49,20.27,82.74c6.06,28.61,14.24,75.06,12.62,94.07,1.6.95,7.33,1,10.56,0,0,0,12.47-65.26-3.26-92.81,5.5-67.79-12.47-84-12.47-84Z",
    fill: "#263238",
    style: {
      transformOrigin: "295.31px 318.771px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M303.44,402.83a28.59,28.59,0,0,1-.47,3.91.78.78,0,0,0,.65,1c3.85.62,9.47-.28,11.25-.6a.82.82,0,0,0,.67-.67l.68-3.65a.79.79,0,0,0-.8-.94l-11.17.21A.83.83,0,0,0,303.44,402.83Z",
    fill: "#263238",
    style: {
      transformOrigin: "309.585px 404.916px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M303.44,402.83a28.59,28.59,0,0,1-.47,3.91.78.78,0,0,0,.65,1c3.85.62,9.47-.28,11.25-.6a.82.82,0,0,0,.67-.67l.68-3.65a.79.79,0,0,0-.8-.94l-11.17.21A.83.83,0,0,0,303.44,402.83Z",
    fill: "#fff",
    opacity: 0.1,
    style: {
      transformOrigin: "309.585px 404.916px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M254.54,402.66c-.08,1-.22,2.83-.38,4.17a.81.81,0,0,0,.7.9,56,56,0,0,0,10.41-.12A.81.81,0,0,0,266,407l.87-3.65a.82.82,0,0,0-.76-1l-10.71-.42A.79.79,0,0,0,254.54,402.66Z",
    fill: "#263238",
    style: {
      transformOrigin: "260.522px 404.921px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M254.54,402.66c-.08,1-.22,2.83-.38,4.17a.81.81,0,0,0,.7.9,56,56,0,0,0,10.41-.12A.81.81,0,0,0,266,407l.87-3.65a.82.82,0,0,0-.76-1l-10.71-.42A.79.79,0,0,0,254.54,402.66Z",
    fill: "#fff",
    opacity: 0.1,
    style: {
      transformOrigin: "260.522px 404.921px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M259.31,185.79a167.31,167.31,0,0,0,.24,17.17c.29,7.46.8,14.79,1.88,27H299c-.75-10.58.48-22.62,7.22-46.41a8.76,8.76,0,0,0-7.49-11.38c-1.49-.15-3.06-.27-4.68-.35a118.08,118.08,0,0,0-17,0c-1.86.17-3.77.4-5.61.65A14.12,14.12,0,0,0,259.31,185.79Z",
    fill: "#fff",
    style: {
      transformOrigin: "282.914px 200.737px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M292.81,152.65c-1.48,5.48-3.3,15.53.26,19.19,0,0-5.19-.78-16.22,6-3.19-4.58-.82-6-.82-6,6.22-1.46,6.4-6,5.66-10.26Z",
    fill: "#ffb573",
    style: {
      transformOrigin: "284.127px 165.245px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m279.17 176.5c2.07 1.38 3 6.74 3 6.74s13.72-5.19 13.22-11.25a35.16 35.16 0 0 1-3.19-2s-10.91 4.42-13.03 6.51z",
    fill: "#16A085",
    style: {
      transformOrigin: "287.287px 176.615px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M275.72,175.92a23.5,23.5,0,0,0-2.27,6c-5.51-4.55.9-10.07.9-10.07a4.65,4.65,0,0,1,3.28-.47A3.88,3.88,0,0,0,275.72,175.92Z",
    fill: "#16A085",
    style: {
      transformOrigin: "274.422px 176.593px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m288.28 156.29-6.59 5.29a17.36 17.36 0 0 1 0.3 3c2.36-0.34 5.76-2.9 6.19-5.34a8.29 8.29 0 0 0 0.1-2.95z",
    opacity: 0.2,
    style: {
      transformOrigin: "285.029px 160.435px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m297.49 141.65c-1.66 8.85-2.18 12.62-7.23 16.87-7.6 6.39-18 3-19-6-0.89-8.12 2-21.24 11.1-24.16a11.53 11.53 0 0 1 15.13 13.29z",
    fill: "#ffb573",
    style: {
      transformOrigin: "284.427px 144.755px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m291.09 130.15c-2.69 7.16 3.07 11.42 4.35 17.61 6.67-4.43 7.14-22.95-4.35-17.61z",
    fill: "#263238",
    style: {
      transformOrigin: "295.268px 138.476px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M292.44,142.12a1.58,1.58,0,0,1-.71-.17A1.53,1.53,0,0,1,291,141a1.57,1.57,0,0,1,.09-1.2,1.59,1.59,0,0,1,.91-.78l4.68-1.52a1.57,1.57,0,1,1,1,3h0L292.92,142A1.61,1.61,0,0,1,292.44,142.12Zm4.68-4.16a1,1,0,0,0-.33.06l-4.68,1.52a1.07,1.07,0,0,0-.69,1.34,1.08,1.08,0,0,0,.53.62,1.07,1.07,0,0,0,.82.07l4.68-1.53a1.06,1.06,0,0,0,.68-1.34,1,1,0,0,0-.53-.62A1,1,0,0,0,297.12,138Zm.41,2.32Z",
    fill: "#fff",
    style: {
      transformOrigin: "294.842px 139.769px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M283.47,143.12c-.11.75-.58,1.33-1.06,1.29s-.78-.67-.68-1.42.59-1.33,1.07-1.29S283.58,142.37,283.47,143.12Z",
    fill: "#263238",
    style: {
      transformOrigin: "282.602px 143.055px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M274.43,142.59c-.11.75-.59,1.33-1.07,1.29s-.78-.67-.67-1.42.58-1.33,1.06-1.29S274.53,141.84,274.43,142.59Z",
    fill: "#263238",
    style: {
      transformOrigin: "273.558px 142.525px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m274 141.22-1.69-0.64s0.69 1.47 1.69 0.64z",
    fill: "#263238",
    style: {
      transformOrigin: "273.155px 141.027px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M276.77,144a22.25,22.25,0,0,1-3.31,4.59,3,3,0,0,0,2.55.69Z",
    fill: "#ed893e",
    style: {
      transformOrigin: "275.115px 146.667px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M279.83,152.36a7.37,7.37,0,0,1-1.25,0,.2.2,0,0,1-.18-.24.24.24,0,0,1,.25-.2,6.28,6.28,0,0,0,5.07-2,.21.21,0,0,1,.31,0,.22.22,0,0,1,0,.31A6.66,6.66,0,0,1,279.83,152.36Z",
    fill: "#263238",
    style: {
      transformOrigin: "281.245px 151.119px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m298.49 149.17a6.17 6.17 0 0 1-4.21 2.7c-2.12 0.24-2.66-2.23-1.63-4.46 0.93-2 3.14-4.55 5.06-3.75s2.11 3.61 0.78 5.51z",
    fill: "#ffb573",
    style: {
      transformOrigin: "295.745px 147.698px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m297.39 152.23a2.16 2.16 0 1 1-2.16-2.16 2.16 2.16 0 0 1 2.16 2.16z",
    fill: "#fff",
    style: {
      transformOrigin: "295.23px 152.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M286.26,138.77a.41.41,0,0,1-.3-.14,3.27,3.27,0,0,0-2.87-1.1.41.41,0,0,1-.49-.34.48.48,0,0,1,.38-.52,4,4,0,0,1,3.64,1.35.44.44,0,0,1-.05.62A.53.53,0,0,1,286.26,138.77Z",
    fill: "#263238",
    style: {
      transformOrigin: "284.661px 137.697px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.89,138.17a.43.43,0,0,1-.31-.08.44.44,0,0,1-.06-.62,4.66,4.66,0,0,1,3.62-1.92.4.4,0,0,1,.38.46.47.47,0,0,1-.48.42,3.73,3.73,0,0,0-2.85,1.56A.5.5,0,0,1,271.89,138.17Z",
    fill: "#263238",
    style: {
      transformOrigin: "273.472px 136.862px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m283 141.76-1.69-0.65s0.69 1.47 1.69 0.65z",
    fill: "#263238",
    style: {
      transformOrigin: "282.155px 141.559px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m295.82 170c-4.17 2.86-9.75 33.62-11.35 79.38a600 600 0 0 0 2.83 82.86s18.27-20.08 29.68-26c0.22-42.7-8.87-71.87-7.82-82.65s7-40.59 2.43-46.19-15.77-7.4-15.77-7.4z",
    fill: "#16A085",
    style: {
      transformOrigin: "300.543px 251.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m295.82 170c-4.17 2.86-9.75 33.62-11.35 79.38a600 600 0 0 0 2.83 82.86s18.27-20.08 29.68-26c0.22-42.7-8.87-71.87-7.82-82.65s7-40.59 2.43-46.19-15.77-7.4-15.77-7.4z",
    fill: "#fff",
    opacity: 0.8,
    style: {
      transformOrigin: "300.543px 251.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m274.68 171.53c-4.86 7.21-15.61 97-5.47 160.67-8-4.44-13.79-16.7-13.79-16.7s-0.79-55.42 3-85.52c-0.78-35.34-4.98-59.28 16.26-58.45z",
    fill: "#16A085",
    style: {
      transformOrigin: "265.016px 251.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m274.68 171.53c-4.86 7.21-15.61 97-5.47 160.67-8-4.44-13.79-16.7-13.79-16.7s-0.79-55.42 3-85.52c-0.78-35.34-4.98-59.28 16.26-58.45z",
    fill: "#fff",
    opacity: 0.8,
    style: {
      transformOrigin: "265.016px 251.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m289.09 230.41a162.59 162.59 0 0 1-6.83-14.78c-3.08-7.78-5.54-17-5.54-17s-23.32-0.88-27.66 1.75c2.54 9.89 13.56 33.75 13.56 33.75s17.63-0.31 26.47-3.72z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "269.075px 216.309px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M265.12,235.68l21.2-.64c2.13-.06,3.23-1.62,2.43-3.46l-13.37-30.81a6,6,0,0,0-5.33-3.23l-21.2.64c-2.13.06-3.22,1.62-2.42,3.46l13.37,30.81A6,6,0,0,0,265.12,235.68Z",
    fill: "#16A085",
    style: {
      transformOrigin: "267.589px 216.61px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M264,236.93a6.28,6.28,0,0,1-5.42-3.38L245.2,202.74a2.66,2.66,0,0,1,.08-2.55,3,3,0,0,1,2.57-1.26l21.19-.64a6.28,6.28,0,0,1,5.57,3.38L288,232.48a2.71,2.71,0,0,1-.08,2.56,3,3,0,0,1-2.57,1.25l-21.2.64H264Zm.13-.5v0l21.2-.64a2.55,2.55,0,0,0,2.15-1,2.19,2.19,0,0,0,0-2.09l-13.37-30.81a5.68,5.68,0,0,0-5.09-3.08l-21.2.64a2.57,2.57,0,0,0-2.16,1,2.2,2.2,0,0,0,0,2.09L259,233.35A5.71,5.71,0,0,0,264.12,236.43Z",
    fill: "#fff",
    style: {
      transformOrigin: "266.598px 217.61px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m276.56 212.63 2.51-1.23a3.28 3.28 0 0 1 3 0.06l4.32 2.35a6 6 0 0 1 3.13 4.61l0.15 1.21c-4 2.32-10.1 1.86-10.1 1.86l-1.75 0.06a2.71 2.71 0 0 1-2.88-2.57l-0.16-3.45a3.1 3.1 0 0 1 1.78-2.9z",
    fill: "#ffb573",
    style: {
      transformOrigin: "282.224px 216.311px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m303.77 189.09c-0.84 13.74-0.89 26.32 2.78 28.44 4.3-4.23 3.99-10.15-2.78-28.44z",
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "306.347px 203.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M313,179.39c.54,1.54,1,2.91,1.41,4.36s.86,2.86,1.26,4.3c.8,2.88,1.57,5.77,2.22,8.71a85.09,85.09,0,0,1,2.38,18.55,3.39,3.39,0,0,1,0,.45v.06a9.25,9.25,0,0,1-2.16,5.12,10.78,10.78,0,0,1-3.31,2.57,18,18,0,0,1-5.25,1.66,45.7,45.7,0,0,1-8.47.5c-2.67,0-5.25-.21-7.81-.45s-5.05-.51-7.72-.91l2-12c2.16.36,4.56.69,6.84.92s4.6.35,6.82.37a33.92,33.92,0,0,0,6.15-.45,6.85,6.85,0,0,0,1.72-.53c.07,0-.08,0-.42.36a3.29,3.29,0,0,0-.76,1.79l0,.52a57.19,57.19,0,0,0-.83-7.57c-.45-2.6-1.09-5.24-1.79-7.86s-1.52-5.25-2.41-7.85c-.45-1.3-.91-2.6-1.4-3.88s-1-2.61-1.46-3.75Z",
    fill: "#16A085",
    style: {
      transformOrigin: "302.914px 202.543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M313,179.39c.54,1.54,1,2.91,1.41,4.36s.86,2.86,1.26,4.3c.8,2.88,1.57,5.77,2.22,8.71a85.09,85.09,0,0,1,2.38,18.55,3.39,3.39,0,0,1,0,.45v.06a9.25,9.25,0,0,1-2.16,5.12,10.78,10.78,0,0,1-3.31,2.57,18,18,0,0,1-5.25,1.66,45.7,45.7,0,0,1-8.47.5c-2.67,0-5.25-.21-7.81-.45s-5.05-.51-7.72-.91l2-12c2.16.36,4.56.69,6.84.92s4.6.35,6.82.37a33.92,33.92,0,0,0,6.15-.45,6.85,6.85,0,0,0,1.72-.53c.07,0-.08,0-.42.36a3.29,3.29,0,0,0-.76,1.79l0,.52a57.19,57.19,0,0,0-.83-7.57c-.45-2.6-1.09-5.24-1.79-7.86s-1.52-5.25-2.41-7.85c-.45-1.3-.91-2.6-1.4-3.88s-1-2.61-1.46-3.75Z",
    fill: "#fff",
    opacity: 0.8,
    style: {
      transformOrigin: "302.914px 202.543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m293.79 132.71c-4.51 4.51-24.74-2.8-23.94 4.7-3.12-7 1.79-14.53 14.26-14.53 15.26 0 12.42 7.12 9.68 9.83z",
    fill: "#263238",
    style: {
      transformOrigin: "282.45px 130.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m239.72 155.76-1-0.3a23.8 23.8 0 0 0 1.12-6.38h1a25.35 25.35 0 0 1-1.12 6.68z",
    fill: "#16A085",
    style: {
      transformOrigin: "239.78px 152.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M239.36,143a24.26,24.26,0,0,0-10.6-15.42l.55-.84a25.26,25.26,0,0,1,11,16.05Z",
    fill: "#16A085",
    style: {
      transformOrigin: "234.535px 134.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M215.42,173.54a25.45,25.45,0,0,1-21.32-39.32l.83.54a24.46,24.46,0,0,0,20.49,37.78Z",
    fill: "#16A085",
    style: {
      transformOrigin: "202.704px 153.88px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 215.44,
    cy: 148.09,
    r: 22.1,
    fill: "#16A085",
    style: {
      transformOrigin: "215.44px 148.09px",
      transform: "rotate(-1.52deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M212.42,161.51l-.29-.19c2.58-6.93,8.81-11.49,12.5-17.7,1.19-2,.39-4.73-1.34-6.27l.18-.38a.77.77,0,0,0-.36-1h0a.77.77,0,0,0-1,.37l-.1.2c-1.91-.76-3.91.17-5.07,2.09-3.69,6.21-9.92,10.77-12.5,17.7h0a.74.74,0,0,0-1,.22.73.73,0,0,0,.22,1l8,5.21a.74.74,0,1,0,.81-1.23Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "214.262px 149.416px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M209.84,151a.5.5,0,0,1-.3-.11.49.49,0,0,1-.09-.7c1-1.23,2-2.47,3-3.67a.5.5,0,1,1,.75.66c-1,1.18-2.06,2.41-3,3.63A.53.53,0,0,1,209.84,151Z",
    fill: "#fff",
    style: {
      transformOrigin: "211.341px 148.667px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M206.08,157.43a.33.33,0,0,1-.17,0,.49.49,0,0,1-.3-.64,21.28,21.28,0,0,1,2.06-4.06.5.5,0,0,1,.85.54,20.21,20.21,0,0,0-2,3.87A.52.52,0,0,1,206.08,157.43Z",
    fill: "#fff",
    style: {
      transformOrigin: "207.088px 154.969px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M217.88,150a.51.51,0,0,1-.32-.12.49.49,0,0,1-.06-.7c.7-.81,1.36-1.59,2-2.37a.49.49,0,0,1,.7-.07.5.5,0,0,1,.07.7c-.65.79-1.32,1.58-2,2.38A.5.5,0,0,1,217.88,150Z",
    fill: "#fff",
    style: {
      transformOrigin: "218.881px 148.312px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M221.69,145.34a.52.52,0,0,1-.29-.09.51.51,0,0,1-.11-.7c.52-.73,1-1.42,1.39-2.11a3,3,0,0,0-.9-3.39.5.5,0,1,1,.66-.74,3.93,3.93,0,0,1,1.1,4.65c-.43.71-.9,1.42-1.44,2.18A.51.51,0,0,1,221.69,145.34Z",
    fill: "#fff",
    style: {
      transformOrigin: "222.54px 141.738px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "174.915px 342.61px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M202.94,296.82c.61,5.19,13.59,3.73,22-3.81-5.23,2.61-16.3.83-21,2.22,1.26-2,2.51-3.93,3.73-5.73,1.26,3.55,10.9,1.77,17-4.29-3.75,2.13-11.72,1.44-15.66,2.42,2-2.9,3.94-5.48,5.66-7.69,2.77,1.18,9.32-2.59,12.59-8.54-3.06,3.14-11.71,4.51-13.85,6.76a2.52,2.52,0,0,0,.38,1c-.83,1.06-1.7,2.21-2.61,3.43-.67-3.27-5.8-9.46-6.07-13.61-1.58,7.63,2,15.88,5.32,14.64-1.49,2.05-3.07,4.29-4.68,6.73-1.21-3.63-7.43-9.94-8.14-14.5-1,8.49,3.61,17.16,7.17,16-1.3,2-2.61,4.1-3.92,6.3-2-4.33-11.23-11.24-13-16.91.32,10.78,7.58,20.76,11.86,18.85q-2,3.39-3.86,7.07c-2.71-4.69-13.63-11.61-16.1-17.83,1.32,12,10.25,22.52,14.92,20.18-1.4,2.83-2.74,5.76-4,8.79-3.36-4.37-16.76-9.33-20.75-15.41,3.95,12.24,15.58,21.27,19.83,17.64a127.89,127.89,0,0,0-4.2,12.44c-4.14-4-18.72-7.13-23.75-12.81,5.87,12,19.12,19.57,23.06,15.34A109.27,109.27,0,0,0,182.52,347c-5.41-3.63-22.29-4.16-29-9.47,8.84,12,24.79,17.77,28.64,12.67a86,86,0,0,0,1.45,28.48l1.13-.26a86.46,86.46,0,0,1-.89-32.19c1.76,6.53,19.31,4.58,30.91-5.49-7.78,3.71-24.46.49-30.48,2.89a111.45,111.45,0,0,1,2.88-12.09c1.87,5.41,17,4.25,27.4-4-6.82,2.89-20.78-.33-26.53,1.21,1.27-3.91,2.7-7.7,4.26-11.34,1.34,5.47,16.11,4.68,26.36-3.16-6.51,2.63-19.66-.6-25.28.69,1.44-3.21,3-6.29,4.52-9.23.6,5.71,15.13,4.86,25-3-6.14,2.62-18.74-.22-24,1.16C200.2,301.45,201.57,299.07,202.94,296.82Z",
    fill: "#16A085",
    style: {
      transformOrigin: "190.39px 323.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M202.94,296.82c.61,5.19,13.59,3.73,22-3.81-5.23,2.61-16.3.83-21,2.22,1.26-2,2.51-3.93,3.73-5.73,1.26,3.55,10.9,1.77,17-4.29-3.75,2.13-11.72,1.44-15.66,2.42,2-2.9,3.94-5.48,5.66-7.69,2.77,1.18,9.32-2.59,12.59-8.54-3.06,3.14-11.71,4.51-13.85,6.76a2.52,2.52,0,0,0,.38,1c-.83,1.06-1.7,2.21-2.61,3.43-.67-3.27-5.8-9.46-6.07-13.61-1.58,7.63,2,15.88,5.32,14.64-1.49,2.05-3.07,4.29-4.68,6.73-1.21-3.63-7.43-9.94-8.14-14.5-1,8.49,3.61,17.16,7.17,16-1.3,2-2.61,4.1-3.92,6.3-2-4.33-11.23-11.24-13-16.91.32,10.78,7.58,20.76,11.86,18.85q-2,3.39-3.86,7.07c-2.71-4.69-13.63-11.61-16.1-17.83,1.32,12,10.25,22.52,14.92,20.18-1.4,2.83-2.74,5.76-4,8.79-3.36-4.37-16.76-9.33-20.75-15.41,3.95,12.24,15.58,21.27,19.83,17.64a127.89,127.89,0,0,0-4.2,12.44c-4.14-4-18.72-7.13-23.75-12.81,5.87,12,19.12,19.57,23.06,15.34A109.27,109.27,0,0,0,182.52,347c-5.41-3.63-22.29-4.16-29-9.47,8.84,12,24.79,17.77,28.64,12.67a86,86,0,0,0,1.45,28.48l1.13-.26a86.46,86.46,0,0,1-.89-32.19c1.76,6.53,19.31,4.58,30.91-5.49-7.78,3.71-24.46.49-30.48,2.89a111.45,111.45,0,0,1,2.88-12.09c1.87,5.41,17,4.25,27.4-4-6.82,2.89-20.78-.33-26.53,1.21,1.27-3.91,2.7-7.7,4.26-11.34,1.34,5.47,16.11,4.68,26.36-3.16-6.51,2.63-19.66-.6-25.28.69,1.44-3.21,3-6.29,4.52-9.23.6,5.71,15.13,4.86,25-3-6.14,2.62-18.74-.22-24,1.16C200.2,301.45,201.57,299.07,202.94,296.82Z",
    opacity: 0.3,
    style: {
      transformOrigin: "190.39px 323.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M172,379l-1.08-.07c2.46-36.61-26.3-67-38.78-78.32l.72-.8C145.45,311.3,174.47,342,172,379Z",
    fill: "#16A085",
    style: {
      transformOrigin: "152.144px 339.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m142.52 310.23c0-2.89 4.86-9.41 4.86-13.49 2.09 7.58-1.38 16.26-4.86 13.49z",
    fill: "#16A085",
    style: {
      transformOrigin: "145.266px 303.749px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m137.14 304.42c-0.26-2.56 3.55-8.73 3.22-12.34 2.46 6.55 0.05 14.47-3.22 12.34z",
    fill: "#16A085",
    style: {
      transformOrigin: "139.248px 298.427px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m147.42 316c0.49-3.64 7.84-11 8.59-16.09 1.25 9.9-4.76 20.09-8.59 16.09z",
    fill: "#16A085",
    style: {
      transformOrigin: "151.799px 308.401px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m152.56 322.79c0.88-4.05 9.8-11.62 11.1-17.33 0.52 11.27-7.15 22.24-11.1 17.33z",
    fill: "#16A085",
    style: {
      transformOrigin: "158.123px 314.727px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m158.24 330.86c1.77-4 12.62-9.94 15.18-15.57-1.86 11.78-12.13 21.5-15.18 15.57z",
    fill: "#16A085",
    style: {
      transformOrigin: "165.83px 323.971px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m164.26 342.2c2.42-3.88 14.52-8.39 18-13.83-3.68 11.89-15.74 20.41-18 13.83z",
    fill: "#16A085",
    style: {
      transformOrigin: "173.26px 336.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m168.42 353.32c3.48-3.83 17.87-6.42 22.85-11.77-6.51 12.5-21.67 19.55-22.85 11.77z",
    fill: "#16A085",
    style: {
      transformOrigin: "179.845px 349.063px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m140.78 308.06c-2.69-1.05-10.52 1.22-14.34-0.23 6.35 4.64 15.67 4.42 14.34 0.23z",
    fill: "#16A085",
    style: {
      transformOrigin: "133.674px 309.514px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m134.75 300.63c-2-1.57-9.29-1.58-12.18-3.76 4.26 5.54 12.27 7.67 12.18 3.76z",
    fill: "#16A085",
    style: {
      transformOrigin: "128.66px 299.749px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m145.43 313.56c-3.49-1.16-13.29 2.26-18.24 0.68 8.38 5.47 20.21 4.55 18.24-0.68z",
    fill: "#16A085",
    style: {
      transformOrigin: "136.419px 315.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m150.63 320c-4-1.07-14.81 3.43-20.48 2 9.79 5.54 23.05 3.71 20.48-2z",
    fill: "#16A085",
    style: {
      transformOrigin: "140.552px 322.586px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m156.66 328.29c-4.26-1-15.58 3.95-21.6 2.54 10.47 5.7 24.44 3.49 21.6-2.54z",
    fill: "#16A085",
    style: {
      transformOrigin: "146.047px 331.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m162.7 338.9c-4.43-1.16-16.33 3.85-22.6 2.28 10.84 6.13 25.46 4.06 22.6-2.28z",
    fill: "#16A085",
    style: {
      transformOrigin: "151.582px 341.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m167.28 350.56c-4.94-1.53-18.66 3.52-25.66 1.43 11.94 7.48 28.58 5.89 25.66-1.43z",
    fill: "#16A085",
    style: {
      transformOrigin: "154.619px 353.574px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m163.86 416.24h24.41a3 3 0 0 0 3-2.7l4.73-45.74a3 3 0 0 0-3-3.32h-33.84a3 3 0 0 0-3 3.32l4.69 45.74a3 3 0 0 0 3.01 2.7z",
    fill: "#16A085",
    style: {
      transformOrigin: "176.08px 390.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m163.86 416.24h24.41a3 3 0 0 0 3-2.7l4.73-45.74a3 3 0 0 0-3-3.32h-33.84a3 3 0 0 0-3 3.32l4.69 45.74a3 3 0 0 0 3.01 2.7z",
    fill: "#fff",
    opacity: 0.6,
    style: {
      transformOrigin: "176.08px 390.36px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroupierWoman);
export default __webpack_public_path__ + "static/media/croupier-woman.230f7a5a324c635b8538d0a17a79962f.svg";
export { ForwardRef as ReactComponent };